import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18nModule } from '@spartacus/core';

import { KnBrQuoteRejectCommentsComponent } from './kn-br-quote-reject-comments.component';

@NgModule({
    imports: [CommonModule, NgSelectModule, FormsModule, I18nModule, KnBrQuoteRejectCommentsComponent],
})
export class KnBrQuoteRejectCommentsModule {}
